import { render } from "./InspectionLog.vue?vue&type=template&id=0535f5fa"
import script from "./InspectionLog.vue?vue&type=script&lang=ts"
export * from "./InspectionLog.vue?vue&type=script&lang=ts"
script.render = render

export default script